import React from 'react'
import PropTypes from 'prop-types'
import Icon from '../../atoms/icon/Icon'

export default function Asterisk({ onClick }) {
  return (
    <div className="asterisk-text">
      <span role="button" data-toggle="modal-lite" onClick={onClick}>
        <Icon name="asterisk" className="icon--xsmall" />
      </span>
    </div>
  )
}

Asterisk.propTypes = {
  onClick: PropTypes.func
}
